import { allCountries } from '../../config';
import { MerchantFeatures } from '../../constants';
import { useFeature } from '../use-features';

export const useAvailableCountries = () => {
  const { hasFeature } = useFeature();

  return [...allCountries, ...(hasFeature(MerchantFeatures.USD_UY_CHECKOUTS) ? ['UX'] : [])];
};
